import React from 'react';
import { LoginPage } from '../../../application/pages';
import { MakeLogin } from '../../../main/factories/usecases';

export const MakeLoginPage = () => {
  return <LoginPage loginData={MakeLogin()} />;
};
